var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RestAuth_1;
import { JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { ConnectionType } from '../connection';
import { ConnectionAuth } from '../connectionAuth';
import './restAuthCredentials';
import './restAuthEndpoint';
import './restAuthPagination';
import { RestAuthEndpoint } from './restAuthEndpoint';
import { restAuthSchemaValidation } from '../../validations.generated';
export const RestBasedConnectionTypes = [
    // REST based placeholder connections
    ConnectionType.NetSuite,
    ConnectionType.SapSuccessFactors,
    ConnectionType.SapCrm,
    ConnectionType.Ukg,
    ConnectionType.OracleHcm,
    ConnectionType.Adp,
    ConnectionType.Dynamics365Sales,
    ConnectionType.CeridianDayforce,
    ConnectionType.OracleCrm,
    ConnectionType.OracleErpCloud,
    ConnectionType.SageIntacct,
    ConnectionType.BambooHr,
    ConnectionType.SapErp,
    ConnectionType.GoogleCloudPlatformCloudStorage,
    ConnectionType.Sas,
    ConnectionType.OneDrive,
    ConnectionType.Dropbox,
    ConnectionType.GoogleDrive,
    ConnectionType.Jira,
    ConnectionType.Monday,
    ConnectionType.Zuora,
    ConnectionType.AdobeAnalytics,
    ConnectionType.ZoomInfo,
    ConnectionType.Marketo,
    ConnectionType.ActiveCampaign,
    ConnectionType.Mailchimp,
    ConnectionType.Infor,
    ConnectionType.CornerstoneOnDemand,
    ConnectionType.Gusto,
    ConnectionType.PaychexFlex,
    ConnectionType.Zendesk,
    ConnectionType.ServiceNow,
    ConnectionType.ZohoCrm,
    ConnectionType.Pipedrive,
    ConnectionType.QuickBooks,
    ConnectionType.Xero,
    ConnectionType.Freshbooks,
    ConnectionType.ZohoBooks,
    ConnectionType.WaveFinancial
];
export const restAuthSchema = {
    $id: 'urn:wisepipe-common-connection:RestAuth',
    type: 'object',
    properties: {
        auth: { $ref: 'urn:wisepipe-common-connection:RestAuthCredentials' },
        endpoints: {
            type: 'object',
            additionalProperties: {
                $ref: 'urn:wisepipe-common-connection:RestAuthEndpoint'
            }
        },
        pagination: { $ref: 'urn:wisepipe-common-connection:RestAuthPagination' },
        subType: { type: 'string', enum: RestBasedConnectionTypes }
    },
    required: ['auth', 'endpoints', 'pagination']
};
let RestAuth = RestAuth_1 = class RestAuth extends ConnectionAuth {
    constructor(nonce, auth, endpoints, pagination, subType) {
        super(ConnectionType.Rest, nonce);
        this.auth = auth;
        this.endpoints = endpoints;
        this.pagination = pagination;
        if (subType)
            this.subType = subType;
        JSON.validate(this, RestAuth_1);
    }
};
__decorate([
    JsonConverter(new MapConverter(RestAuthEndpoint))
], RestAuth.prototype, "endpoints", void 0);
RestAuth = RestAuth_1 = __decorate([
    JsonSchemaV2(restAuthSchema, restAuthSchemaValidation),
    JsonDiscriminatorValue(ConnectionType.Rest)
], RestAuth);
export { RestAuth };
//# sourceMappingURL=restAuth.js.map